/** Textes « analytique » — le français fait foi. */
export const analytique = {
  verdicts: { a_garder: 'A garder', a_surveiller: 'À surveiller', a_vendre: 'A vendre' } as Record<string, string>,
  /** Langue des mois abrégés (« août 26 »). */
  localeMois: 'fr-FR',
  titre: 'Analyses',
  sousTitre: 'Mois en cours · réservé aux gérants',
  nbMois: (n: number) => `${n} mois`,
  kpi: {
    utilisation: 'Taux d\'utilisation', utilisationDetail: 'cible du métier 75–85 %',
    revenu: 'Revenu par voiture / jour', revenuDetail: 'RevPAC',
    prixMoyen: 'Prix moyen journalier', prixMoyenDetail: 'réellement pratiqué',
    duree: 'Durée moyenne', dureeValeur: (j: number) => `${j} j`, dureeDetail: (n: number) => `${n} location(s)`,
  },
  diagnostic: 'Diagnostic',
  refus: {
    titre: 'L\'argent que vous ne voyez pas',
    detail: (n: number) => `${n} demande(s) refusée(s) faute de véhicule disponible sur la période`,
    categorie: 'Catégorie la plus demandée', refus: 'Refus', manque: 'Manque a gagner',
    note: 'Chaque recherche de disponibilité restée sans résultat est enregistrée et valorisée au tarif moyen de la flotte. C\'est ce qui vous dira quand acheter le véhicule suivant.',
  },
  parMois: {
    titre: 'Par voiture et par mois',
    vehicule: 'Véhicule', total: 'Total', marge: 'Marge',
    infobulle: (j: number, m: string) => `${j} jour(s) loué(s) · ${m}`,
    colonnes: {
      mois: 'Mois', locations: 'Locations', joursLoues: 'Jours loués', caLocation: 'CA location',
      supplements: 'Suppléments', prixMoyen: 'Prix moyen / jour', entretien: 'Entretien',
      joursGarage: 'Jours au garage', marge: 'Marge',
    },
    noteAvant: 'Chaque case est le taux d\'occupation du mois. ',
    noteGras: 'Cliquez une ligne',
    noteApres: ' pour le détail : locations, jours loués, prix moyen réellement pratiqué, entretien et jours au garage. Une location à cheval sur deux mois est répartie au prorata des jours.',
  },
  rentabilite: {
    titre: 'Rentabilité, véhicule par véhicule',
    colonnes: {
      vehicule: 'Véhicule', immatriculation: 'Immatriculation', joursLoues: 'Jours loués', utilisation: 'Utilisation',
      ca: 'CA', entretien: 'Entretien', marge: 'Marge nette', verdict: 'Verdict',
    },
  },
  equipe: {
    titre: 'Activité de l\'équipe',
    colonnes: {
      personne: 'Personne', reservations: 'Réservations', contrats: 'Contrats', encaisse: 'Encaissé',
      edl: 'États des lieux', dommages: 'Dommages non constatés', corrections: 'Demandes de correction',
    },
    dommagesInfobulle: 'Dommages découverts au retour mais absents du constat de départ — chacun est une perte sèche',
    note: 'Ces indicateurs mesurent le travail produit. Le logiciel n\'enregistre ni position, ni temps de présence, ni activité hors de l\'application.',
  },
};
